import React, { useEffect } from "react";
import NumberFormat from "react-number-format";
import { formatDate } from "../../../../../utils/utils";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import Illustration from "../../../../../partials/content/Illustration";
const AssetDisposals = ({ assetDisposals, onRefresh }) => {
  const { reload } = useGlobalData();
  const assetDisposalsDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  useEffect(() => {}, [reload]);

  return (
    <React.Fragment>
      {assetDisposals.length ? (
        <React.Fragment>
          <CustomDataTable
            data={assetDisposals}
            dataDetailColumns={assetDisposalsDetailColumn}
            onRefreshData={() => {
              onRefresh();
            }}
            columns={[
              {
                header: "Asset Disposal ID",
                field: "ID",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Disposal Type",
                field: "disposalTypeName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Quantity",
                field: "qty",
                body: (rowData) => (
                  <div>
                    {rowData.qty} {rowData.uom.uomName}
                  </div>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit",
                field: "uom.uomName",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Disposal Date",
                field: "disposalDate",
                body: (rowData) => formatDate(rowData.disposalDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currency.currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Unit Asset Value",
                field: "unitAssetValue",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.unitAssetValue}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Unit Sell Price",
                field: "unitSellPrice",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.unitSellPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Profit Amount",
                field: "gainAssetDisposal",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.gainAssetDisposal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="text-success float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Loss Amount",
                field: "lossAssetDisposal",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.lossAssetDisposal}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="text-danger float-right">
                        {rowData.currency.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Profit / Loss Amount",
                field: "gainAssetDisposal",
                body: (rowData) => {
                  if (rowData.gainAssetDisposal > 0) {
                    return (
                      <NumberFormat
                        value={rowData.gainAssetDisposal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="text-success float-right">
                            {rowData.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    );
                  } else if (rowData.lossAssetDisposal < 0) {
                    return (
                      <NumberFormat
                        value={rowData.lossAssetDisposal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="text-danger float-right">
                            {rowData.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    );
                  } else {
                    return (
                      <NumberFormat
                        value={rowData.gainAssetDisposal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {rowData.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    );
                  }
                },
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            guidance="You don't have any Asset Disposals for this asset yet"
            guidanceLeftIcon="fas fa-info-circle kt-font-warning"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default AssetDisposals;
